export const menu = [
  {
    id: "all-users",
    title: "allUsers",
    translate: "navigations.allUsers",
    type: "item",
    icon: "users",
    url: "dashboard/admin/all-users",
    users: ["admin"],
  },
  {
    id: "all-waters",
    title: "allWaters",
    translate: "navigations.allWaters",
    type: "item",
    icon: "droplet",
    url: "dashboard/admin/all-waters",
    users: ["admin"],
  },
  {
    id: "all-fishes",
    title: "allFishes",
    translate: "navigations.allFishes",
    type: "item",
    icon: "shield",
    url: "dashboard/admin/all-fishes",
    users: ["admin"],
  },
  {
    id: "age-of-fishes",
    title: "ageOfFishes",
    translate: "navigations.ageOfFishes",
    type: "item",
    icon: "calendar",
    url: "dashboard/admin/age-of-fishes",
    users: ["admin"],
  },
  {
    id: "years",
    title: "years",
    translate: "navigations.years",
    type: "item",
    icon: "calendar",
    url: "dashboard/admin/years",
    users: ["admin"],
  },
  {
    id: "management-registers",
    title: "managementRegisters",
    translate: "navigations.managementRegisters",
    type: "item",
    icon: "file-text",
    url: "dashboard/admin/management-registers",
    users: ["admin"],
  },
  {
    id: "all-origins",
    title: "allFishes",
    translate: "navigations.allOrigins",
    type: "item",
    icon: "file-text",
    url: "dashboard/admin/all-origins",
    users: ["admin"],
  },
  {
    id: "all-fish-stocking-reports",
    title: "allFishStockingReports",
    translate: "navigations.allFishStockingReports",
    type: "item",
    icon: "file-text",
    url: "dashboard/admin/all-fish-stocking-reports",
    users: ["admin"],
  },
  {
    id: "all-fish-catch-reports",
    title: "allFishCatchReports",
    translate: "navigations.allFishCatchReports",
    type: "item",
    icon: "file-text",
    url: "dashboard/admin/all-fish-catch-reports",
    users: ["admin"],
  },
  {
    id: "all-observation-sheets",
    title: "allFishCatchReports",
    translate: "navigations.allObservationSheets",
    type: "item",
    icon: "file-text",
    url: "dashboard/admin/all-observation-sheets",
    users: ["admin"],
  },
  {
    id: "all-bird-count-reports",
    title: "allBirdCountReports",
    translate: "navigations.allBirdCountReports",
    type: "item",
    icon: "file-text",
    url: "dashboard/admin/all-bird-count-reports",
    users: ["admin"],
  },
  {
    id: "all-bird-damage-reports",
    title: "allBirdDamageReports",
    translate: "navigations.allBirdDamageReports",
    type: "item",
    icon: "file-text",
    url: "dashboard/admin/all-bird-damage-reports",
    users: ["admin"],
  },
  {
    id: "fish-stocking",
    title: "fishStocking",
    translate: "navigations.fishStocking",
    type: "item",
    icon: "droplet",
    url: "dashboard/owner/fish-stocking",
    users: ["owner"],
  },
  {
    id: "fish-catch",
    title: "fishCatch",
    translate: "navigations.fishCatch",
    type: "item",
    icon: "book-open",
    url: "dashboard/owner/fish-catch",
    users: ["owner"],
  },
  {
    id: "observation-sheet",
    title: "observationSheet",
    translate: "navigations.observationSheet",
    type: "item",
    icon: "file-text",
    url: "dashboard/owner/observation-sheet",
    users: ["owner"],
  },
  {
    id: "bird-count",
    title: "birdCount",
    translate: "navigations.birdCount",
    type: "item",
    icon: "file-text",
    url: "dashboard/owner/bird-count",
    users: ["owner"],
  },
  {
    id: "bird-damage",
    title: "birdDamage",
    translate: "navigations.birdDamage",
    type: "item",
    icon: "file-text",
    url: "dashboard/owner/bird-damage",
    users: ["owner"],
  },
];
